import { HttpHeaders, HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { LocalInitFile, DataSnapResult, DataSnapSessionInfo } from './json-interface';
import { InfoConnection } from './utilit-http-connection';
import { CUtilit, CookieManagment } from './utilit';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

/**
 * Methode simplifier pour se connecter au serveur datasnap
 */
export class ArmaServConnection {

    // Type de reponse pour le serveur datasnap (si requete ok) :
    // 'Result'
    // 'SessionExpired'
    // 'error'


    // Pour DATANSAP si on veux faire passer l'id de la sesion il y à deux moyen.....
    // 1 (Safe)    : | Utiliser le 'Pragma' de l'entête de la requete & lui passer l'info suivant  : dssession='ID_DE_LA_SESSION'
    //               |--------------------------------------------------------------------------------------------------------------
    // 2 (nonSafe) : | Utiliser une parameter http (visible sur la requette) avec les info suivant : SESSIONID=ID_DE_LA_SESSION
    //               | ! Provoque des soucis si plusieurs requete est lancé en même temps.
    //               | ! Fait quand on veux telecharger un document spécifique depuis le server datanasp.
    //               | ! Unsafe car expose la clé de session dans la requete qui peut etre intercepter (mais comme on est pas en https on peut intersepter aussi l'entete)

    // INFO
    // Eviter d'utiliser { HttpParams } de angular l'utilisation ne permet pas d'ajouter les param propre a armaserv, interface any fonctione tres bien.

    private static sArmaservPath: string = 'datasnap/rest';         // Nom du chemain vers le serveur
    private static sArmaServCachePath: string = 'datasnap/cache';   // Pour traitement sur les session du serveur // Marche pas ?
    private static sComponentName: string = 'TServerMethods';       // Nom de la classe utiliser pour armaServ
    private static CST_LOCAL_STORAGE_SESSION_ID: string = 'DSSID';  // Acces au localstorage pour stocker l'id de la session
    private static CST_LOCAL_STORAGE_SESSION_TIMOUT: string = 'DSSTIMOUT';  // Session timeout

    private static sArmaorJSON: LocalInitFile; // Donnée enregistrer en memoire apres la premiere requete http

    /**
     * Retourne le chemin d'acces vers arma serv
     * avec la methode et les arguments passées en param
     * CLASS / METHODENAME / ARG1 / ARG2
     * @param methodName ?
     * @param param ?
     */
    public static getArmaServMethodPath(methodName: string, param: any[] | null = null): string {
        let result: string = this.sArmaservPath + '/' + this.sComponentName + '/' + methodName;
        if (param != null) {
            param.forEach(element => {
                result = result + '/' + element;
            });
        }
        return result;
    }

    public static async getArmaServConnection(http: HttpClient, armaServerMethodPath: string): Promise<InfoConnection> {
        const armJson = await this.getArmaorJson(http);
        return new InfoConnection(
            http,
            armJson.ARMASERV_IP,
            armJson.ARMASERV_PORT,
            armaServerMethodPath,
            armJson.HTTPS
        );
    }

    /**
     * Verifie si la session enregistrer est toujours valide
     * @param http Angular HttpClient
     * @returns - undefined : Si on n'a pas reussi a connaitre l'état de la session actuel
     *          - true      : Si la session est toujours valide
     *          - false     : Si la session est expiré ou fermé
     */
    public static async isSessionValid(http: HttpClient): Promise<boolean> {
        let sesisonValid = false;
        try {
            const armaorJSON = await this.getArmaorJson(http);
            const infoConnection = new InfoConnection(
                http,
                armaorJSON.ARMASERV_IP,
                armaorJSON.ARMASERV_PORT,
                this.getArmaServMethodPath('EchoString', ['TOTO']),
                armaorJSON.HTTPS
            );
            // Ajout de l'id de la session dans l'entêt de la page
            const header = infoConnection.DEFAUT_HEADER_JSON_UTF8;
            const infoSession = this.getArmaServeSessionInfo();
            if (infoSession.dssession != '')
                header.Pragma = 'dssession=' + infoSession.dssession;
            infoConnection.setCustomHeader(header);
            //infoConnection.setCustomParams(this.addSessionIdHttpParam({}));
            // Exec de la requette
            const result = await infoConnection.GETFunction().toPromise();
            // Il faut sauvegarder l'identifiant de session si on en avait pas précedament.
            if (result.status == 200) {
                this.saveArmaServSessionFromResponse(result);
                sesisonValid = true;
            }
        } catch (e) {
            if (e instanceof HttpErrorResponse) {
                if (e.status == 403) {
                    sesisonValid = false;
                    this.removeArmaServeSessionInfo();
                } else {
                    // On ne gere pas les autre erreur possible alors on remonte l'exception
                    throw e;
                }
            } else {
                // On ne gere pas les autre erreur possible alors on remonte l'exception
                console.error(e);
                throw e;
            }
        }
        return sesisonValid;
    }

    /**
     * Code pour fermer la session : (NE MARCHE PAS ????????)
     *  Pour fermer votre session avant son expiration,
     *  effectuez une requête GET avec l'URL suivante,
     *  en vous assurant de passer aussi l'ID de la session dans l'en-tête Pragma de la requête :
     *  http://host:port/datasnap/rest/CloseSession/
     *
     * Src: http://docwiki.embarcadero.com/RADStudio/Rio/fr/Protocole_de_messagerie_DataSnap_REST
     * (NE MARCHE PAS ????????)
     *
     * Ducoup pour fermer la session j'appel une methode 'CloseSession' que j'ai crée sur TServerMethods ¯\_(ツ)_/¯
     *
     * @param http ?
     * @param idSession ?
     */
    public static async closeSession(http: HttpClient, idSession: any = undefined): Promise<boolean> {
      const armaorJSON = await this.getArmaorJson(http);
      const infoConnection = new InfoConnection(
        http,
        armaorJSON.ARMASERV_IP,
        armaorJSON.ARMASERV_PORT,
        this.getArmaServMethodPath('CloseSession', []),
        armaorJSON.HTTPS
      );
      // Ajout de l'id de la session dans l'entêt de la page
      const header = infoConnection.DEFAUT_HEADER_JSON_UTF8;
      // Si l'id de la session est undefined, on ferme la session en cours
      if (idSession === undefined) {
        const infoSession = this.getArmaServeSessionInfo();
        if (infoSession.dssession != '')
          header.Pragma = 'dssession=' + infoSession.dssession;
      } else {
        header.Pragma = 'dssession=' + idSession;
      }
      infoConnection.setCustomHeader(header);
      // Exec de la requette
      const result = await infoConnection.GETFunction<DataSnapResult>().toPromise();
      // Il faut sauvegarder l'identifiant de session si on en avait pas précedament.
      if (result.status == 200)
        return result.body?.result[0];
      return false;
    }

    /**
     * Verifie sur le serveur si la session actuel est connecté (client/chantier/utilisateur) à armaserv ou non
     * @param http Client http pour effectuer la requette vers armaserv
     * @returns True si l'utilisateur est connecté sinon false
     */
    public static async isConnected(http: HttpClient): Promise<boolean> {
        let isConnected = false;
        try {
            const armaorJSON = await this.getArmaorJson(http);
            const infoConnection = new InfoConnection(
                http,
                armaorJSON.ARMASERV_IP,
                armaorJSON.ARMASERV_PORT,
                this.getArmaServMethodPath('IsConnected', []),
                armaorJSON.HTTPS
            );
            const header = infoConnection.DEFAUT_HEADER_OCTETSTREAM;
            if (this.getArmaServeSessionInfo().dssession)
                header.Pragma = 'dssession=' + this.getArmaServeSessionInfo().dssession;
            infoConnection.setCustomHeader(header);
            const dataSnapResult = await infoConnection.GETFunction<DataSnapResult>().toPromise();
            isConnected = dataSnapResult.body?.result[0];
        } catch (e) {
            console.error(e);
            isConnected = false;
        }
        return isConnected;
    }

    public static async aGET(http: HttpClient,
                             methodName: string, argument: any[] | null = null,
                             directRequest: boolean = false): Promise<DataSnapResult> {
      let result = undefined;
      try {
        const infoConnection = await this.initInfoConnection(http, methodName, argument);
        let getResponse;
        if (directRequest)
          getResponse = await infoConnection.GETFunction().toPromise();
        else
          getResponse = await infoConnection.addToQueue('get').toPromise();
        this.saveArmaServSessionFromResponse(getResponse);
        result = getResponse.body;
      } catch (e) {
        if (e instanceof HttpErrorResponse && e.status == 403) {
              CUtilit.showAlertSessionExpired();
              this.removeArmaServeSessionInfo();
          }
        throw e;
      }
      return result;
    }

    public static async aPOST(http: HttpClient,
                              methodName: string,
                              body: any,
                              argument: any[] | null = null): Promise<DataSnapResult> {
        let result = undefined;
        if (await this.isSessionValid(http)) {
          const infoConnection = await this.initInfoConnection(http, methodName, argument, body);
          const resultPost: HttpResponse<any> = await infoConnection.addToQueue('post').toPromise();
          this.saveArmaServSessionFromResponse(resultPost);
          result = resultPost.body;
        } else {
            CUtilit.showAlertSessionExpired();
        }
        return result;
    }

    public static async aPut(http: HttpClient,
                             methodName: string,
                             body: any,
                             argument: any[] | null = null): Promise<DataSnapResult> {
      let dataSnapResult = undefined;
      if (await this.isSessionValid(http)) {
        const infoConnection = await this.initInfoConnection(http, methodName, argument, body);
        const resultPut: HttpResponse<any> = await infoConnection.addToQueue('put').toPromise();
        this.saveArmaServSessionFromResponse(resultPut);
        dataSnapResult = resultPut.body;
      } else {
        CUtilit.showAlertSessionExpired();
      }
      return dataSnapResult;
    }

  /**
   * Retourne un object InfoConnection
   */
    private static async initInfoConnection(http: HttpClient,
                                            methodName: string,
                                            argument: any[] | null = null,
                                            body?: any): Promise<InfoConnection> {
      const armJson = await this.getArmaorJson(http);
      const infoConnection = new InfoConnection(
        http,
        armJson.ARMASERV_IP,
        armJson.ARMASERV_PORT,
        this.getArmaServMethodPath(methodName, argument),
        armJson.HTTPS
      );
      const header = infoConnection.DEFAUT_HEADER_JSON_UTF8;
      const sessionInfo = this.getArmaServeSessionInfo();
      if (sessionInfo.dssession)
        header.Pragma = 'dssession=' + sessionInfo.dssession;
      infoConnection.setCustomHeader(header);
      if (body)
        infoConnection.setBody(body);
      return infoConnection;
    }

    public static async getSafeUrlImgFromDatasnap(http: HttpClient, sanitizer: DomSanitizer, methodName: string, methodParam: any[]): Promise<SafeUrl> {
        const armJson = await this.getArmaorJson(http);
        const armaorSessionInfo = this.getArmaServeSessionInfo();
        const headers: any = {};
        if (armaorSessionInfo.dssession)
            headers.Pragma = 'dssession=' + armaorSessionInfo.dssession;
        const infoConnection: InfoConnection = new InfoConnection(
            http,
            armJson.ARMASERV_IP,
            armJson.ARMASERV_PORT,
            this.getArmaServMethodPath(methodName, methodParam),
            armJson.HTTPS
        );
        infoConnection.setCustomHeader(headers);
        infoConnection.setCustomParams({'json': false});        // Pour le cas d'une image on ne veux pas retourner l'image dans un tableau de json
        infoConnection.setReponseType('blob');                  // On recup en blob que l'on va parser pour avoir une URL exploitable
        const result = await infoConnection.addToQueue('get').toPromise();
        return sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(result.body));
    }

    // ! post signifie que l'on envoir la requete en POST pour recuperer une image
    public static async aPostSafeurlImgFromDatasnap(http: HttpClient,
                                                    sanitizer: DomSanitizer,
                                                    methodName: string,
                                                    body: any,
                                                    methodParam: any[] | null = null): Promise<SafeUrl> {
        const armJson = await this.getArmaorJson(http);
        const armaorSessionInfo = this.getArmaServeSessionInfo();
        const headers: any = {};
        if (armaorSessionInfo.dssession)
            headers.Pragma = 'dssession=' + armaorSessionInfo.dssession;
        const infoConnection: InfoConnection = new InfoConnection(
            http,
            armJson.ARMASERV_IP,
            armJson.ARMASERV_PORT,
            this.getArmaServMethodPath(methodName, methodParam),
            armJson.HTTPS
        );
        infoConnection.setCustomHeader(headers);
        infoConnection.setBody(body);
        infoConnection.setCustomParams({'json': false});        // Pour le cas d'une image on ne veux pas retourner l'image dans un tableau de json
        infoConnection.setReponseType('blob');                  // On recup en blob que l'on va parser pour avoir une URL exploitable
        const result = await infoConnection.addToQueue('post').toPromise();
        //const result = await this.aPOST(http, methodName, body, methodParam);
        return sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(result.body));
    }

    /**
     * Traitement apres l'envoi d'une requete POST ou GET depuis le serveur http
     * - Traitre l'entete pour recuperer l'id de la session
     * - Verifie le corps de la réponse pour verifier si la session est toujours active
     *
     * @param serverReponse ?
     */
    private static saveArmaServSessionFromResponse(serverReponse: HttpResponse<any>) {
      function extractArmaServSessionInfoFromHeader(header: HttpHeaders): DataSnapSessionInfo {
        // Exempla de pragma lors d'une réponse du server datasnap : dssession=825268.288919.612108,dssessionexpires=1200000
        let sessionID = '';
        let sessionExpired = NaN;
        if (header && header.get('Pragma')) {
          header.get('Pragma')?.split(',').forEach(info => {
            const dataContent = info.split('=');
            if (dataContent.length > 1) {
              if (dataContent[0] == 'dssession')
                sessionID = dataContent[1];
              else if (dataContent[0] == 'dssessionexpires')
                sessionExpired = +dataContent[1];
            }
          });
        }
        return { dssession: sessionID, dssessionexpires: sessionExpired };
      }
      // Sauvegarde de l'id de la session dans le localStorage
      const sessionInfo = extractArmaServSessionInfoFromHeader(serverReponse.headers);     // On recuperer les donnée de la session en cours
      this.insertArmaServeSessionInfo(sessionInfo); // On stock les donnée de la session dans le local storage
    }

    private static insertArmaServeSessionInfo(sessionInfo: DataSnapSessionInfo) {
        localStorage.setItem(this.CST_LOCAL_STORAGE_SESSION_ID, sessionInfo.dssession);
        localStorage.setItem(this.CST_LOCAL_STORAGE_SESSION_TIMOUT, sessionInfo.dssessionexpires.toString());

        const sessionExpiredHour = sessionInfo.dssessionexpires / 36000000;   // Convert de la durée d'expiration de la session en heure
        //console.log('Conversion session en heure', sessionExpiredHour);

        CookieManagment.setCookie(this.CST_LOCAL_STORAGE_SESSION_ID, sessionInfo.dssession, sessionExpiredHour);
    }

    private static getArmaServeSessionInfo(): DataSnapSessionInfo {
        let sessionID = '';
        let sessionExpired = NaN;
        //console.log('TEST COOKIE: ', CookieManagment.getCookie(this.CST_LOCAL_STORAGE_SESSION_ID) + '"');
        if (localStorage.getItem(this.CST_LOCAL_STORAGE_SESSION_ID))
            sessionID = localStorage.getItem(this.CST_LOCAL_STORAGE_SESSION_ID) || '';
        if (localStorage.getItem(this.CST_LOCAL_STORAGE_SESSION_TIMOUT))
            sessionExpired = +(localStorage.getItem(this.CST_LOCAL_STORAGE_SESSION_TIMOUT) || '');
        return { dssession: sessionID, dssessionexpires: sessionExpired };
    }

    /**
     * Supprime du local storage l'id de la session enregistré
     */
    public static removeArmaServeSessionInfo() {
        localStorage.removeItem(this.CST_LOCAL_STORAGE_SESSION_ID);
        CookieManagment.removeCookie(this.CST_LOCAL_STORAGE_SESSION_ID);
    }

    /**
     * Appel une fonction spécifique du serveur rest & retourne sont contenue en PDF
     * @param http          HttpClient
     * @param methodName    Methode sur serveur a appeler
     * @param methodParam   Tableau de param pour l'appel de la methode
     * @param download      Affiche le fichier sur la page our le telechager
     * @param fileName      Nom du fichier qui va etre telecharger
     */
    public static async getPDF(http: HttpClient, methodName: string, methodParam: string[], download: boolean = false, fileName: string = 'file.pdf') {
        const armaorJSON = await this.getArmaorJson(http);
        const infoCo = new InfoConnection(
            http,
            armaorJSON.ARMASERV_IP,
            armaorJSON.ARMASERV_PORT,
            this.getArmaServMethodPath(methodName, methodParam),
            armaorJSON.HTTPS
        );
        // Param de l'entête
        const header = infoCo.DEFAUT_HEADER_JSON_UTF8;
        const sessionInfo = this.getArmaServeSessionInfo();
        if (sessionInfo.dssession != '') header.Pragma = 'dssession=' + sessionInfo.dssession;
        infoCo.setCustomHeader(header);
        // Param des params
        const params: any = {};
        params.ContentType = 'application/pdf';
        params.json = false;
        if (download) params.filename = fileName;
        if (sessionInfo.dssession)
            params.SESSIONID = sessionInfo.dssession;
        infoCo.setCustomParams(params);

        // Changement de page
        infoCo.setChangePageOnNavigate(true);

        // Exec
        infoCo.addToQueue('navigate');
    }

    /**
     * Appel la fonction GetFile de armaServ avec le chemin donnée en parametre
     * Ne passe pas l'id de la session pour faire la navigation
     * @param http          HttpClient
     * @param filePath      Chemin du fichier sur le serveur rest "C:\..."
     * @param fileName      Nom du fichier qui va etre telecharger (ne correspond pas au nom du fichier présent sur le serveur)
     * @param downloadFile  Affiche le fichier sur la page our le telechager
     * @param changePage    On change de page pour faire la requette
     */
    public static async getFile(http: HttpClient, filePath: string, fileName: string, downloadFile: boolean = false, changePage: boolean = true) {
        const armaorJSON = await this.getArmaorJson(http);
        const infoConnection = new InfoConnection(
            http,
            armaorJSON.ARMASERV_IP,
            armaorJSON.ARMASERV_PORT,
            this.getArmaServMethodPath('GetFile', []),
            armaorJSON.HTTPS
        );

        // Ajout des params
        const httpParam: any = {};
        httpParam.filePath = filePath;
        httpParam.MIME = this.getMIMEFromFile(filePath);
        if (downloadFile || httpParam.MIME == 'application/octet-stream')
            httpParam.fileName = fileName;
        httpParam.json = false;
        infoConnection.setCustomParams(httpParam);

        // Changement de page
        infoConnection.setChangePageOnNavigate(changePage);

        // exec
        infoConnection.addToQueue('navigate');
    }

    public static async downloadFile(http: HttpClient, methodName: string, methodParam: string[], fileName: string) {
        const armaorJSON = await this.getArmaorJson(http);
        const infoCo = new InfoConnection(
            http,
            armaorJSON.ARMASERV_IP,
            armaorJSON.ARMASERV_PORT,
            this.getArmaServMethodPath(methodName, methodParam),
            armaorJSON.HTTPS
        );
        // Param de l'entête
        //let header = infoCo.DEFAUT_HEADER_JSON_UTF8;
        const sessionInfo = this.getArmaServeSessionInfo();
        //if (sessionInfo.dssession != '') header.Pragma = 'dssession=' + sessionInfo.dssession;
        //infoCo.setCustomHeader(header);
        // Param des params http
        const httpParam: any = {};
        httpParam.filename = fileName;
        //httpParam.ContentType = 'application/zip';
        if (sessionInfo.dssession)
            httpParam.SESSIONID = sessionInfo.dssession;
        httpParam.json = false;
        infoCo.setCustomParams(httpParam);
        // Changement de page
        infoCo.setChangePageOnNavigate(true);
        // Exec
        infoCo.addToQueue('navigate');
    }

    /**
     * Lit le fichier local et retourne un json du fichier armaor.json du programme.
     * Si les donnée n'existe pas alors recupere et enregistre avec une requete http.
     */
    public static async getArmaorJson(http: HttpClient): Promise<LocalInitFile> {
        if (this.sArmaorJSON) return this.sArmaorJSON;
        let promise: LocalInitFile = {
            ARMASERV_IP: window.location.hostname,
            ARMASERV_PORT: window.location.port,
            HTTPS : window.location.protocol == 'https:'
        };
        try {
            promise = await http.get<LocalInitFile>('/armaor.json').toPromise();
        } catch (e) {
            if (e instanceof HttpErrorResponse)
                console.log('Using local connection', e);
            else
                console.error(e);
        }
        if (promise) this.sArmaorJSON = promise;
        console.log('window.location.protocol : ', window.location.protocol);
        console.log('promise : ', promise);
        return promise;
    }

    public static async LogoutArmawebAngular(router: Router, http: HttpClient) {
        await ArmaServConnection.aGET(http, 'LogoutUser', []);
        CUtilit.LogoutAngular(router);
    }

  /**
   * Split le fichier donnée pour recuperer la fin du fichier .xxx afin de determiner le type de page html a afficher
   * @param fileName fileName avec ou sans folder
   * https://developer.mozilla.org/fr/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
   */
  public static getMIMEFromFile(fileName: string): string {
    const result = 'application/octet-stream';
    const splitFileName = fileName.split('.');
    if (splitFileName.length > 0) {
      switch (splitFileName[splitFileName.length - 1]) {
        case 'jpg': return 'image/jpeg';
        case 'bmp': return 'image/bmp';
        case 'pdf': return 'application/pdf';
        case 'zip': return 'application/zip';
        // ......
      }
    }
    return result;
  }
}
